import { render } from "./Messages.vue?vue&type=template&id=bea45322"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=bea45322&lang=scss"
import "./Messages.vue?vue&type=style&index=1&id=bea45322&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__